<template>
  <modal-component
    v-if="openModal"
    :active="openModal"
    titleModal="Actualizar contraseña"
    optionalText="Ingresa tu nueva contraseña. Asegúrate de que sea segura y difícil de adivinar."
    textSave="Actualizar"
    @hdlOnClick="changePassword"
    @cancel="close"
    :loader="loading"
  >
    <form class="rp-form" @submit.prevent="changePassword">

      <div class="rp-field">
        <label class="rp-label">Contraseña actual</label>
        <div class="control has-icons-right">
          <input
            class="input"
            :type="!showOldPassword ? 'password' : 'text'"
            name="password"
            placeholder="Contraseña actual"
            autofocus=""
            autocomplete="off"
            v-model="oldPassword"
          />
          <a class="icon is-small is-right" @click="viewOldPassword()">
            <i class="far fa-eye" v-if="!showOldPassword"></i>
            <i class="far fa-eye-slash" v-else></i>
          </a>
        </div>
        <div v-if="isSamePass" class="rp-inline-error">
          <i class="fas fa-exclamation-circle"></i>
          {{ isPasswordCompared }}
        </div>
      </div>

      <div class="rp-field">
        <label class="rp-label">Nueva contraseña</label>
        <div class="control has-icons-right">
          <input
            class="input"
            :type="!showNewPassword ? 'password' : 'text'"
            placeholder="Nueva contraseña"
            name="password"
            v-model="newPassword"
            @input="onInput"
          />
          <a class="icon is-small is-right" @click="viewNewPassword()">
            <i class="far fa-eye" v-if="!showNewPassword"></i>
            <i class="far fa-eye-slash" v-else></i>
          </a>
        </div>
        <ul v-if="newPassword" class="rp-checklist" :class="{ 'all-met': allValidationsMet }">
          <li :class="{ 'is-met': validations.minCharacters }">
            <i :class="validations.minCharacters ? 'fas fa-check-circle' : 'far fa-circle'"></i>
            Al menos 10 caracteres
          </li>
          <li :class="{ 'is-met': validations.lowercase }">
            <i :class="validations.lowercase ? 'fas fa-check-circle' : 'far fa-circle'"></i>
            Una letra minúscula
          </li>
          <li :class="{ 'is-met': validations.uppercase }">
            <i :class="validations.uppercase ? 'fas fa-check-circle' : 'far fa-circle'"></i>
            Una letra mayúscula
          </li>
          <li :class="{ 'is-met': validations.symbol }">
            <i :class="validations.symbol ? 'fas fa-check-circle' : 'far fa-circle'"></i>
            Un número y un símbolo
          </li>
        </ul>
      </div>

      <div class="rp-field">
        <label class="rp-label">Confirmar nueva contraseña</label>
        <div class="control has-icons-right">
          <input
            class="input"
            :type="!showRepeatedPassword ? 'password' : 'text'"
            name="password2"
            placeholder="Repetir contraseña"
            autocomplete="off"
            v-model="repeatedPassword"
            @input="inputconfirmPassword"
          />
          <a class="icon is-small is-right" @click="viewRepeatedPassword()">
            <i class="far fa-eye" v-if="!showRepeatedPassword"></i>
            <i class="far fa-eye-slash" v-else></i>
          </a>
        </div>
        <div v-if="isPasswordMatching" class="rp-match-status" :class="{ 'is-match': isMatch }">
          <i :class="isMatch ? 'fas fa-check-circle' : 'fas fa-times-circle'"></i>
          {{ isPasswordMatching }}
        </div>
      </div>

    </form>
  </modal-component>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'

export default {
  name: 'ChangePassword',
  components: {
    ModalComponent: () => import('@/components/ui/ModalComponent')
  },
  props: {
    openModal: {
      type: Boolean,
      default: false
    },
    close: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {
      oldPassword: '',
      newPassword: null,
      repeatedPassword: null,
      showNewPassword: false,
      showOldPassword: false,
      showRepeatedPassword: false,
      isMatch: false,
      isValid: false,
      isSamePass: false,
      regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{6,})/,
      loading: false,
      showValidation: false,
      validations: {
        minCharacters: false,
        lowercase: false,
        uppercase: false,
        symbol: false
      }
    }
  },
  computed: {
    ...mapState({ authentication: state => state.authentication }),
    isPasswordMatching () {
      if (this.newPassword && this.repeatedPassword) {
        if (this.newPassword !== this.repeatedPassword) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.isMatch = false
          return 'Las contraseñas no coinciden' && null
        } else {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.isMatch = true
          return 'Las contraseñas coinciden'
        }
      }
      return null
    },
    validOldPassword () {
      if (this.oldPassword) {
        if (this.regex.test(this.oldPassword)) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.isValid = true
          return 'La contraseña es válida'
        } else {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.isValid = false
          return 'La contraseña debe tener un número (0-9), al menos una letra minúscula (a-z) y mayúscula (A-Z), un carácter especial (@#$%&!) y 6 caracteres de largo.'
        }
      } else {
        return null
      }
    },
    allValidationsMet () {
      return Object.values(this.validations).every(v => v)
    },
    isPasswordCompared () {
      if (this.newPassword && this.oldPassword) {
        if (this.newPassword === this.oldPassword) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.isSamePass = true
          return 'La contraseña actual no puede coincidir con la nueva.'
        }
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.isSamePass = false
      return null
    }
  },
  methods: {
    ...mapActions(['changePass']),
    ...mapMutations(['setAuthenticationValue']),
    viewOldPassword () {
      this.showOldPassword = !this.showOldPassword
    },
    viewRepeatedPassword () {
      this.showRepeatedPassword = !this.showRepeatedPassword
    },
    viewNewPassword () {
      this.showNewPassword = !this.showNewPassword
    },
    changePassword () {
      this.loading = true
      const data = {
        oldPassword: this.oldPassword,
        newPassword: this.newPassword
      }
      this.changePass(data).then(resp => {
        this.loading = false
        if (resp) {
          this.$router.push('/')
        }
      })
    },
    onInput () {
      if (!this.showValidation && this.newPassword.length > 0) {
        this.showValidation = true
      } else if (this.newPassword.length <= 0) {
        this.showValidation = false
      }
      this.validatePassword()
    },
    validatePassword () {
      const value = this.newPassword
      this.validations.minCharacters = value.length >= 10
      this.validations.lowercase = /[a-z]/.test(value)
      this.validations.uppercase = /[A-Z]/.test(value)
      this.validations.symbol = /\d/.test(value) && /[^A-Za-z0-9]/.test(value)
    },
    getClass (isValid) {
      return isValid ? 'has-text-success' : 'has-text-danger'
    },
    inputconfirmPassword () {
      if (this.repeatedPassword.length > 0 && this.repeatedPassword !== this.newPassword) {
        this.notMatch = true
      } else if (this.repeatedPassword.length > 0) {
        this.notMatch = false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.rp-form {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.rp-field {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.rp-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: #4a5568;
}

.control.has-icons-right .icon {
  pointer-events: all;
}

.rp-inline-error {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.78rem;
  color: #ff3860;
  padding-left: 0.5rem;
  border-left: 3px solid #ff3860;
  margin-top: 0.1rem;

  i { font-size: 0.8rem; }
}

.rp-checklist {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  padding: 0.65rem 0.85rem;
  background: #f8f9fb;
  border: 1px solid #e8ecf0;
  border-radius: 6px;
  list-style: none;
  margin: 0;
  transition: background 0.3s ease, border-color 0.3s ease;

  &.all-met {
    background: #f0fdf7;
    border-color: #a3e9cb;
  }

  li {
    display: flex;
    align-items: center;
    gap: 0.45rem;
    font-size: 0.78rem;
    color: #9ba3af;
    transition: color 0.2s ease;

    i { font-size: 0.75rem; transition: color 0.2s ease; }

    &.is-met {
      color: #2ecc87;
      i { color: #2ecc87; }
    }
  }
}

.rp-match-status {
  display: inline-flex;
  align-self: flex-start;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.75rem;
  font-weight: 500;
  padding: 0.25rem 0.65rem;
  border-radius: 20px;
  background-color: rgba(255, 56, 96, 0.1);
  color: #ff3860;

  i { font-size: 0.75rem; }

  &.is-match {
    background-color: rgba(46, 204, 135, 0.12);
    color: #2ecc87;
  }
}
</style>
